export default [
    {
        id: 1,
        name_ca: 'Habitatge',
        name_en: 'Housing',
        name_es: 'Vivienda',
        bde_code: 'V'
    },
    {
        id: 2,
        name_ca: 'Oficina',
        name_en: 'Office',
        name_es: 'Oficina',
        bde_code: 'L'
    },
    {
        id: 3,
        name_ca: 'Altres',
        name_en: 'Others',
        name_es: 'Otros',
        bde_code: 'O'
    }
]



// WEBPACK FOOTER //
// ./src/options/usage_types_bde.js